var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainPoint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 38",
    style: {
      enableBackground: "new 0 0 38 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EAA7FA;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 10.3,
    className: "st0",
    width: 17.3,
    height: 17.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    transform: "translate(0 0.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    className: "st1",
    d: "M13.4,35.7H4.7C3.3,35.7,2,34.5,2,33V22.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V33 c0,0.9,0.7,1.6,1.6,1.6h8.6c0.3,0,0.5,0.2,0.5,0.5C13.9,35.5,13.7,35.7,13.4,35.7L13.4,35.7L13.4,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    className: "st1",
    d: "M36,23.1V33c0,1.5-1.2,2.7-2.7,2.7l0,0H25c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0h8.3 c0.9,0,1.6-0.7,1.6-1.6l0,0v-9.9c0-0.3,0.2-0.5,0.5-0.5S36,22.8,36,23.1L36,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    className: "st1",
    d: "M23.9,1.8h9.4C34.7,1.8,36,3,36,4.5c0,0,0,0,0,0V14c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V4.5 c0-0.9-0.7-1.6-1.6-1.6l0,0h-9.4c-0.3,0-0.5-0.2-0.5-0.5S23.6,1.8,23.9,1.8L23.9,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    className: "st1",
    d: "M2,13.8V4.5C2,3,3.3,1.8,4.7,1.8h9.1c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H4.7 c-0.9,0-1.6,0.7-1.6,1.6v9.3c0,0.3-0.2,0.5-0.5,0.5S2,14.1,2,13.8L2,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    className: "st1",
    d: "M25.2,18.8h0.5c0,3.7-3,6.7-6.7,6.7s-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7c0,0,0,0,0,0 c3.7,0,6.7,3,6.7,6.7l0,0h-1.1c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6c0,3.1,2.5,5.6,5.6,5.6c3.1,0,5.6-2.5,5.6-5.6H25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    className: "st1",
    d: "M19.5,15.6V22c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5v-6.5c0-0.3,0.2-0.5,0.5-0.5 C19.3,15,19.5,15.3,19.5,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    className: "st1",
    d: "M15.8,18.2h6.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5h-6.5c-0.3,0-0.5-0.2-0.5-0.5 C15.2,18.5,15.5,18.2,15.8,18.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPoint);
export default __webpack_public_path__ + "static/media/pain-point.ed9854984a0db4fc4b2db9cc6453b2b1.svg";
export { ForwardRef as ReactComponent };